/* eslint-disable camelcase */

import dom from '../../../wrapper/DomWrapper';
import SingleProduct from '../../Ecommerce/ecwid/custom/SingleProduct';
import Ecommerce from '../../../ecommerce/ecwid/custom';

import { getLabelClass } from './utils';
import { getImageSize } from '../../Ecommerce/ecwid/custom/utils';
import { getProductMinHeight } from '../../Ecommerce/ecwid/custom/ProductsWidget';
import { ASPECT_RATIO } from '../../../../components/Ecommerce/Ecwid/Custom/constants';

const preInit = async () => ({
  provider: Ecommerce.provider,
});

/**
 * this - LayoutController bound to the function
 * @returns product
 */
function preRender(product, index, elContainer) {
  const {
    layoutSettings: {
      grid: { items_per_row } = {},
      layoutType,
    },
  } = this.settings;
  let imageSize = 'imageOriginalUrl';

  if (elContainer && layoutType === 'grid' && items_per_row) {
    imageSize = getImageSize(dom.getElementWidth(elContainer) / items_per_row);
  }

  return {
    product,
    withLabel: getLabelClass(product),
    withGallery: product.images.length > 1,
    imageSize,
  };
}

function postRender(element, product, index) {
  (new SingleProduct(dom.getElement('div.product', element), product)).init(index);
  return element;
}

// eslint-disable-next-line no-unused-vars
function didMount(container) {
  const {
    layoutSettings: {
      grid: { total_rows = 1 } = {},
      aspectRatio,
      display,
    },
  } = this.settings;
  const width = this.getElementWidth();
  const minHeight = total_rows * getProductMinHeight(width, display, ASPECT_RATIO[aspectRatio]);

  dom.updateStyle(container, { minHeight: `${minHeight}px` });
}

export default {
  preInit,
  preRender,
  postRender,
  didMount,
};
